import { render, staticRenderFns } from "./CopyIM.vue?vue&type=template&id=55b91461&lang=pug"
import script from "./CopyIM.vue?vue&type=script&lang=js"
export * from "./CopyIM.vue?vue&type=script&lang=js"
import style0 from "./CopyIM.vue?vue&type=style&index=0&id=55b91461&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports